// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2nma-","itemLink":"style_itemLink__FJf1-","itemPic":"style_itemPic__1j3B0","itemIcon":"style_itemIcon__1WPb1"};